import SessionDetailsView from './components/session-details-view';

export default SessionDetailsView;
